import React, { useEffect } from 'react';
import { useLazyGetLogisticsCenterByIdQuery } from "../../../../redux/api/organic/logisticsCenterApi";
import { Descriptions, Modal, Spin, Typography } from "antd";
import i18n from "i18next";

interface LogisticsCenterDetailsModalProps {
  id: number | null;
  show: boolean;
  onHide: () => void;
}

export const LogisticsCenterDetailsModal: React.FC<LogisticsCenterDetailsModalProps> = ({
																						  id,
																						  show,
																						  onHide
																						}) => {
  const [fetchCenter, { data, isFetching }] = useLazyGetLogisticsCenterByIdQuery();

  useEffect(() => {
	if (id !== null && show) {
	  fetchCenter(id);
	}
  }, [id, show]) ;

  return (
	<Modal
	  title="Детали логистического центра"
	  open={show}
	  onCancel={onHide}
	  footer={null}
	  width={1000}
	>
	  {isFetching ? (
		<Spin style={{ display: "flex", justifyContent: "center" }} />
	  ) : (
		data && (
		  <>
			<Descriptions bordered column={1} size="middle" title="Основная информация">
			  <Descriptions.Item label="Название">{data.res?.centerName ?? '-'}</Descriptions.Item>
			  <Descriptions.Item label="Владелец">{data.res?.owner ?? '-'}</Descriptions.Item>
			  <Descriptions.Item label="Год ввода в эксплуатацию">{data.res?.commissioningYear ?? '-'}</Descriptions.Item>
			  <Descriptions.Item label="Примечание">{data.res?.description ?? '-'}</Descriptions.Item>
			  <Descriptions.Item label="Регион">
				{i18n.language === 'ru'
				  ? data.res?.region?.nameRu ?? '-'
				  : data.res?.region?.nameKy ?? '-'}
			  </Descriptions.Item>
			  <Descriptions.Item label="Район">
				{i18n.language === 'ru'
				  ? data.res?.area?.nameRu ?? '-'
				  : data.res?.area?.nameKy ?? '-'}
			  </Descriptions.Item>
			  <Descriptions.Item label="Территориальная единица">
				{i18n.language === 'ru'
				  ? data.res?.territorialUnit?.nameRu ?? '-'
				  : data.res?.territorialUnit?.nameKy ?? '-'}
			  </Descriptions.Item>
			  <Descriptions.Item label="Форма собственности">
				{i18n.language === 'ru'
				  ? data.res?.ownershipType?.nameRu ?? '-'
				  : data.res?.ownershipType?.nameKy ?? '-'}
			  </Descriptions.Item>
			  <Descriptions.Item label="Статус реестра">
				{i18n.language === 'ru'
				  ? data.res?.registerStatus?.nameRu ?? '-'
				  : data.res?.registerStatus?.nameKy ?? '-'}
			  </Descriptions.Item>
			</Descriptions>

			<Typography.Title level={4} style={{ marginTop: 24 }}>
			  Профили вместимости ({data.res?.capacity?.length ?? 0})
			</Typography.Title>

			{data.res?.capacity && data.res.capacity.length > 0 ? (
			  data.res.capacity.map((cap, idx) => (
				<Descriptions
				  key={cap.id || idx}
				  bordered
				  size="small"
				  column={1}
				  title={`Профиль #${idx + 1}`}
				  style={{ marginTop: 16 }}
				>
				  <Descriptions.Item label="Площадь складов (м²)">
					{cap.storageAreaM2 ?? '-'}
				  </Descriptions.Item>
				  <Descriptions.Item label="Суточная пропускная способность (т)">
					{cap.dailyThroughputTon ?? '-'}
				  </Descriptions.Item>
				  <Descriptions.Item label="Объем холодного хранения (м³)">
					{cap.coldStorageVolumeM3 ?? '-'}
				  </Descriptions.Item>
				  <Descriptions.Item label="Транспортная доступность">
					{i18n.language === 'ru'
					  ? cap.transportAccess?.nameRu ?? '-'
					  : cap.transportAccess?.nameKy ?? '-'}
				  </Descriptions.Item>
				  <Descriptions.Item label="Сертификаты">
					{i18n.language === 'ru'
					  ? cap.certifications?.nameRu ?? '-'
					  : cap.certifications?.nameKy ?? '-'}
				  </Descriptions.Item>
				  <Descriptions.Item label="Услуги">
					{i18n.language === 'ru'
					  ? cap.availableServices?.nameRu ?? '-'
					  : cap.availableServices?.nameKy ?? '-'}
				  </Descriptions.Item>
				</Descriptions>
			  ))
			) : (
			  <Typography.Text type="secondary">Нет данных о вместимости.</Typography.Text>
			)}
		  </>
		)
	  )}
	</Modal>
  );
};
